
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clobe/sales-settlement",
      function () {
        return require("private-next-pages/clobe/sales-settlement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clobe/sales-settlement"])
      });
    }
  